import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles(theme => ({
  acceptedColumnsAlert: {
    marginBottom: "2rem",
    width: "80%",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  }
}));
